// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.cryptokara",
    name: "Cryptokara",
    homepage: "https://cryptokara.com",
    image_id: "028ef53f-b5d9-4a63-2bf0-d384c8522500",
    app: {
        browser: null,
        ios: null,
        android: "https://play.google.com/store/apps/details?id=com.cryptokara&hl=en_US",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: "com.cryptokara",
    mobile: {
        native: "cryptokara://StartScreen",
        universal: "https://play.google.com/store/apps/details?id=com.cryptokara&hl=en_US",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map